import { useState } from "react";

const PaymentTab = ({ total, pm }) => {
  const [paymentMethod, setPaymentMethod] = useState("");

  const handlePaymentMethodChange = (e) => {
    const value = e.target.value;
    setPaymentMethod(value);
    pm(value); // Pass the selected payment method to the parent component
  };

  return (
    <div className="space-y-6">
      <div className="p-4 bg-white rounded-md">
        <h3 className="font-semibold mb-4">Payment Method</h3>
        <div className="space-y-4">
          <label className="flex items-center space-x-3 cursor-pointer">
            <input
              type="radio"
              name="payment"
              value="cod"
              checked={paymentMethod === "cod"}
              onChange={handlePaymentMethodChange}
              className="form-radio h-5 w-5 text-indigo-600"
            />
            <span className="text-gray-700">Cash on Delivery</span>
          </label>
          
          <label className="flex items-center space-x-3 cursor-pointer">
            <input
              type="radio"
              name="payment"
              value="online"
              checked={paymentMethod === "online"}
              onChange={handlePaymentMethodChange}
              className="form-radio h-5 w-5 text-indigo-600"
            />
            <span className="text-gray-700">Razor Pay</span>
          </label>
          
          <label className="flex items-center space-x-3 cursor-pointer">
            <input
              type="radio"
              name="payment"
              value="crypto"
              checked={paymentMethod === "crypto"}
              onChange={handlePaymentMethodChange}
              className="form-radio h-5 w-5 text-indigo-600"
            />
            <span className="text-gray-700">Crypto Wallet</span>
          </label>
        </div>

        <div className="mt-6 space-y-2">
          <div className="flex justify-between text-gray-600">
            <span>SubTotal</span>
            <span>₹{total.toFixed(2)}</span>
          </div>
          <div className="flex justify-between text-gray-600">
            <span>Delivery Charge</span>
            <span>₹0.00</span>
          </div>
          <div className="flex justify-between font-semibold pt-2 border-t border-gray-200">
            <span>Total</span>
            <span>₹{total.toFixed(2)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentTab;
